import isUndefined from 'lodash/isUndefined';
import merge from 'lodash/merge';

/**
 * Takes an array of markets and merges the markets that have the same id.
 * @param {Array} markets array of markets to be merged.
 * @returns {Array} merged array of markets.
 */
export const mergeMarkets = (markets) => {
    const mergedMarkets = markets.reduce((acc, market) => {
        const { id: marketId } = market;

        return {
            ...acc,
            [marketId]: merge(acc[marketId], market),
        };
    }, {});

    return Object.values(mergedMarkets);
};

export const getMarketBetable = (market) => {
    const {
        betable: marketBetable,
        suspended: marketSuspended,
        tradable: marketTradable,
        active: marketActive,
    } = market;

    if (!isUndefined(marketBetable)) {
        return marketBetable;
    }
    if (!isUndefined(marketSuspended)) {
        return !marketSuspended;
    }
    if (!isUndefined(marketTradable) && !isUndefined(marketActive)) {
        return marketTradable && marketActive;
    }

    return false;
};

/**
 * @param {Object} event event object
 * @returns {Array<number>} market ids as numbers
 */
export const getDefaultMarkets = (event) => {
    const { grouped_market_ids = [], market_id } = event;

    // using Set will make the market id's unique which is important if this
    // is to be used to register for ws updates.
    return [...new Set([...grouped_market_ids, market_id])].map(Number);
};
